import {Injectable} from "@angular/core";
import { Subject }    from 'rxjs/Subject';
import {FamilyAlbum} from "../../model/family-album";
import {BusinessTransaction} from "../../model/business-transaction";
import {BusinessService} from "../data/business.service";
import {CurrentBusinessService} from "./currentBusinessService";

@Injectable()
export class CurrentTransactionService {

  private transactionChangedSource = new Subject<BusinessTransaction>();

  currentTransaction:BusinessTransaction;

  transactionChange$ = this.transactionChangedSource.asObservable();

  constructor(private businessService: BusinessService,
              private currentBusinessService: CurrentBusinessService) {

  }

  createNewTransaction(): void {
    this.businessService.createTransaction(this.currentBusinessService.currentBusiness.id).subscribe(
        transaction => {
          this.currentTransaction = transaction;
          this.transactionChangedSource.next(transaction);
        }
    )
  }
  
}



// WEBPACK FOOTER //
// node_modules/angular2-template-loader!./~/tslint-loader?{"configFile":"tslint.json"}!./src/app/services/communication/currentTransactionService.ts